 import Vue from 'vue';
 import Vuex from 'vuex';
import app from './modules/app';
import user from './modules/user';
import permission from './modules/permission';
import getters from './getters';
import cilentType from './modules/cilentType';
Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    app,
    user,
    permission,
    cilentType
  },
  getters
});

export default store



// WEBPACK FOOTER //
// ./src/store/index.js